import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Form, Input } from "antd";
import FormItem from "components/fields/FormItem";
import { requiredField } from "utils/crudSagaHelper";
import { Award, Briefcase, Mail, Phone, UserPlus } from "lucide-react";
import TextArea from "antd/es/input/TextArea";
import { 
  doClientReferralCreate 
} from "../../../../../redux/clientreferral/clientReferralState";
import ButtonWithConfirm from "components/button/buttonwithconfirm";


const ClientReferralForm = () => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const currentUserId = useSelector((state) => state.auth.user?.id);
  
  const onSubmit = (formData) => {
      const payload = {
        crf_id: formData.crf_id || undefined,
        crf_contact_name: formData.crf_contact_name,
        crf_email: formData.crf_email,
        crf_contact_number: formData.crf_contact_number,
        crf_company_name: formData.crf_company_name,
        crf_industry: formData.crf_industry,
        crf_additional_info: formData.crf_additional_info,
      };

      if (!payload.crf_id) delete payload.crf_id;

      dispatch(doClientReferralCreate(payload));
  };

  return (
      <Form
        layout="vertical"
        form={form}
        onFinish={onSubmit}
      >
          <FormItem
			        name="crf_id"
			        hidden
			    >
			        <Input type="hidden"/>
			    </FormItem>

        <div className="w-full">
          <FormItem
            className="font-medium mb-2"
            name="crf_contact_name"
            label="Contact Name"
            rules={[requiredField()]}

          >
            <Input
              placeholder="Enter client contact name"
              className="input-field"
            />
          </FormItem>

          <FormItem
            className="font-medium mb-2"
            name="crf_email"
            label="Email"
            rules={[requiredField()]}
          >
            <Input
              placeholder="contact@company.com"
              className="input-field"
              prefix={<Mail className="w-4 h-4 text-gray-600"/>}
            />
          </FormItem>

          <FormItem
            className="font-medium mb-2"
            name="crf_contact_number"
            label="Phone"
          >
            <Input
              placeholder="+1 (555) 000-0000"
              className="input-field"
              prefix={<Phone className="w-4 h-4 text-gray-600"/>}
            />
          </FormItem>

          <FormItem
            className="font-medium mb-2"
            name="crf_company_name"
            label="Company Name"
            rules={[requiredField()]}
          >
            <Input
              placeholder="e.g., Tech Solutions Inc."
              className="input-field"
              prefix={<Briefcase className="w-4 h-4 text-gray-600"/>}
            />
          </FormItem>

          <FormItem
            className="font-medium mb-2"
            name="crf_industry"
            label="Industry"
            rules={[requiredField()]}
          >
            <Input
              className="input-field"
              placeholder="e.g., Technology, Healthcare, Finance"
            />
          </FormItem>

          <FormItem
            className="font-medium mb-3"
            name="crf_additional_info"
            label="Additional Notes (Optional)"
          >
            <TextArea
              className="input-field"
              maxLength={255}
              placeholder="Tell us about their business needs or challenges..."
            />
          </FormItem>
        </div>
        <ButtonWithConfirm
          block
          className="btn-approve w-full h-9 bg-gradient-to-r from-emerald-600 to-green-600"
          confirmLabel="Confirm"
          confirmationTitle="Submit Client Referral"
          confirmationMessage="Are you sure you want to submit this client referral?"
          confirmHandler={() => {
            form.submit();
          }}
        >
          <UserPlus className="w-4 h-4"/> Submit Client Referral
        </ButtonWithConfirm>

        <div className="my-2 flex items-start gap-2 p-3 rounded-xl bg-emerald-50 border border-emerald-200 dark:bg-emerald-900 dark:border-emerald-700">
          <Award className="w-4 h-4 text-emerald-600 dark:text-emerald-500"/>
          <p className="text-[11px] text-emerald-800 dark:text-emerald-200 leading-relaxed">
            Earn <span className="font-semibold">Hyvid Points</span> for every client referral that leads to a successful partnership
          </p>
        </div>
      </Form>
 

  );
};
export default ClientReferralForm;